import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './GDPRBanner.css';

const GDPRBanner: React.FC = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the banner
    const dismissed = localStorage.getItem('gdpr_banner_dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('gdpr_banner_dismissed', 'true');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="gdpr-banner">
      <div className="gdpr-banner-content">
        <div className="gdpr-banner-text">
          <p>
            {t('home.gdprBanner.message')}
          </p>
        </div>
        <button 
          className="gdpr-banner-close" 
          onClick={handleDismiss}
          aria-label={t('home.gdprBanner.close')}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default GDPRBanner;

